import React from 'react';
import { RadioGroup, Form } from 'rsuite';
import { RsNumberInput } from 'components/Rsuite/Input';
import { FormikErrors } from 'formik';
import styles from './brandSelection.module.scss';
import { RadioCell } from 'components/Rsuite/Radio/RadioCell';
import { BudgetType } from 'core/rtbCampaign/singlePage/common';
import { numberWithCommas } from 'utils/StringUtil';

type BudgetPrices = Record<string, string>;
interface Ipros {
  values: any;
  diffDays: number;
  suggestDailyTargetBudget: number[];
  errors: FormikErrors<any>;
  onBudgetTypeChange: (v: BudgetType) => void;
  onBudgetChange: (v: BudgetPrices) => void;
}

const BudgetRadios: React.FC<Ipros> = ({
  values,
  diffDays,
  suggestDailyTargetBudget,
  errors,
  onBudgetTypeChange,
  onBudgetChange,
}) => {
  // 切換 Radio
  const handleChange = (budgetType) => {
    onBudgetTypeChange(budgetType);
  };

  // 兩個 InputNumber 共用
  const handlePriceChange = (field: BudgetType, price: string) => {
    onBudgetChange({ type: field, newPrice: price });
  };

  return (
    <RadioGroup
      value={values.basic.budgetType}
      onChange={handleChange}
      className={styles.RsDateRangeRadioGroup}
      inline
    >
      <RadioCell
        value={BudgetType.DAILY}
        label='設定每日預算'
        customBottom={
          values.basic.budgetType === BudgetType.DAILY &&
          suggestDailyTargetBudget.length > 0 && (
            <>
              <Form.HelpText className='text-nowrap'>
                根據商品設定與走期，建議日預算{' '}
                {numberWithCommas(suggestDailyTargetBudget[0])} -{' '}
                {numberWithCommas(suggestDailyTargetBudget[1])}
              </Form.HelpText>
              <Form.HelpText className='text-nowrap'>
                您設定的總預算預估為{' '}
                {numberWithCommas(Number(values.basic.budget).toFixed(2))}
              </Form.HelpText>
            </>
          )
        }
        customRight={
          values.basic.budgetType === BudgetType.DAILY && (
            <div className='relative'>
              <RsNumberInput
                prefix='NTD'
                num={values.basic.dailyTargetBudget}
                onChange={(price) => handlePriceChange(BudgetType.DAILY, price)}
                placeholder='請輸入金額' // i18n
                disabled={values.basic.budgetType === BudgetType.TOTAL}
              />
              <Form.ErrorMessage
                show={
                  (errors.basic as { dailyTargetBudget?: string })
                    ?.dailyTargetBudget !== undefined ||
                  (errors.basic as { budget?: string })?.budget !== undefined
                }
                placement='topEnd'
              >
                {/* 這邊這樣寫不好, 根本解決方法是在 initialvalues 定義完整型別 */}
                {(errors.basic as { dailyTargetBudget?: string })
                  ?.dailyTargetBudget
                  ? (errors.basic as { dailyTargetBudget?: string })
                      ?.dailyTargetBudget
                  : (errors.basic as { budget?: string })?.budget}
              </Form.ErrorMessage>
            </div>
          )
        }
      />
      <RadioCell
        value={BudgetType.TOTAL}
        label='設定活動總預算'
        customBottom={
          values.basic.budgetType === BudgetType.TOTAL &&
          suggestDailyTargetBudget.length > 0 && (
            <Form.HelpText>
              根據商品設定與走期，建議總預算{' '}
              {numberWithCommas(suggestDailyTargetBudget[0] * diffDays)} -{' '}
              {numberWithCommas(suggestDailyTargetBudget[1] * diffDays)}
              <br />
              預算消耗速度依競爭情況浮動, 可能於走期結束前消耗完畢
            </Form.HelpText>
          )
        }
        customRight={
          values.basic.budgetType === BudgetType.TOTAL && (
            <div className='relative'>
              <RsNumberInput
                prefix='NTD'
                num={values.basic.budget}
                onChange={(price) => handlePriceChange(BudgetType.TOTAL, price)}
                placeholder='請輸入金額' // i18n
                disabled={values.basic.budgetType === BudgetType.DAILY}
              />
              <Form.ErrorMessage
                show={
                  (errors.basic as { budget?: string })?.budget !== undefined
                }
                placement='topEnd'
              >
                {/* 這邊這樣寫不好, 根本解決方法是在 initialvalues 定義完整型別 */}
                {(errors.basic as { budget?: string })?.budget}
              </Form.ErrorMessage>
            </div>
          )
        }
      />
    </RadioGroup>
  );
};

export default BudgetRadios;
